/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Analytics_GovernanceInputs */



/**
* | output |
* | --- |
* | "OpenAI-compatible API gateway for custom integrations" |
*
* @param {Pricing_Feature_Analytics_GovernanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_analytics_governance = /** @type {((inputs?: Pricing_Feature_Analytics_GovernanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Analytics_GovernanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("OpenAI-kompatibles API-Gateway für benutzerdefinierte Integrationen")
	return /** @type {LocalizedString} */ ("OpenAI-compatible API gateway for custom integrations")
});